export const KANBAN_TEMPLATES = [
  { key: 'BLANK', lists: [] },
  {
    key: 'SALES',
    lists: [
      'Novo Lead',
      'Qualificação',
      'Proposta Enviada',
      'Negociação',
      'Fechado/Ganho',
    ],
  },
  {
    key: 'SUPPORT',
    lists: ['Novo', 'Em Atendimento', 'Aguardando Cliente', 'Resolvido'],
  },
  { key: 'HR', lists: ['Triagem', 'Entrevista', 'Proposta', 'Contratado'] },
];
